import React from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import {
  Col, Container, Row, Spinner,
} from 'react-bootstrap';
import * as Yup from 'yup';
import Select from 'react-select';
import { isEqual } from 'lodash';
import { addPhoneFormatting } from '../../utils/formatters';
import { Media } from '../../structures/models/media/media';
import { CLOUDINARY_UPLOAD_PRESET_TESTIMONIAL } from '../../utils/constants';
import TinyMceField from './Partials/TinyMceField';
import CloudinaryUploadField from './Partials/Cloudinary/CloudinaryUploadField';
import RecaptchaDisclaimer from './Partials/RecaptchaDisclaimer';

interface FormValues {
  name: string,
  email: string,
  body: string,
  breeder_phone: string,
  breeder_name: string,
  title: string,
  slug?: string,
  images: Array<Media>,
  status?: string,
  id?: number,
}

interface Props {
  validator: Yup.ObjectSchema<any>,
  formValues: FormValues,
  handleClose?: () => void,
  onSubmit: (values: FormValues) => Promise<any>,
  loading: boolean
  canUpdateStatus?: boolean,
  cloudinaryIsUpdating: boolean,
  setCloudinaryIsUpdating: (isUpdating: boolean) => void,
  isEditForm?: boolean,
}

const TestimonialForm: React.FC<Props> = ({
  formValues,
  validator,
  onSubmit,
  handleClose,
  loading,
  canUpdateStatus,
  setCloudinaryIsUpdating,
  cloudinaryIsUpdating,
  isEditForm,
}) => {
  return (
    <Formik
      enableReinitialize
      initialValues={formValues}
      validationSchema={validator}
      onSubmit={async (values) => onSubmit(values)}
    >
      {(formikProps) => {
        const {
          errors,
          touched,
          values,
          dirty,
          isValid,
          handleChange,
          setFieldTouched,
          setFieldValue,
        } = formikProps;
        return (
          <Form id="testimonialsForm">
            <Container fluid>
              <button type="button" className="close" onClick={handleClose} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <Row className="w-100">
                <Col md={12} lg={12}>
                  <div className="p-md-6 p-sm-3 p-1 row">
                    <h2
                      className="text-center text-blue-500"
                    >
                      {isEditForm ? 'Edit Testimonial' : 'Share a Testimonial!'}
                    </h2>
                    <div className="w-100">
                      <Row>
                        <Col>
                          <div className="form-group">
                            {/* eslint-disable-next-line max-len */}
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              className="font-weight-bold"
                              htmlFor="name"
                            >
                              Name
                            </label>
                            <Field
                              name="name"
                              type="text"
                              className={`form-control${errors.name && touched.name ? ' is-invalid' : ''}`}
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </Col>
                        <Col>
                          <div className="form-group">
                            {/* eslint-disable-next-line max-len */}
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              className="font-weight-bold"
                              htmlFor="email"
                            >
                              Email
                            </label>
                            <Field
                              name="email"
                              type="text"
                              className={`form-control${errors.email && touched.email ? ' is-invalid' : ''}`}
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="form-group">
                            {/* eslint-disable-next-line max-len */}
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              className="font-weight-bold"
                              htmlFor="breeder_name"
                            >
                              Breeder Name
                            </label>
                            <Field
                              name="breeder_name"
                              id="breeder_name"
                              type="text"
                              className={`form-control${errors.breeder_name && touched.breeder_name ? ' is-invalid' : ''}`}
                            />
                            <ErrorMessage
                              name="breeder_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </Col>
                        <Col>
                          <div className="form-group">
                            {/* eslint-disable-next-line max-len */}
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              className="font-weight-bold"
                              htmlFor="breeder_phone"
                            >
                              Breeder Phone Num.
                            </label>
                            <input
                              id="breeder_phone"
                              className={`form-control${errors.breeder_phone && touched.breeder_phone ? ' is-invalid' : ''}`}
                              type="text"
                              value={values.breeder_phone}
                              onChange={(e) => {
                                const newValue = addPhoneFormatting(e.target.value);
                                setFieldValue('breeder_phone', newValue);
                              }}
                            />
                            <ErrorMessage
                              name="breeder_phone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row className="w-100">
                        <Col md={12} lg={12}>
                          <div className="form-group">
                            {/* eslint-disable-next-line max-len */}
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              className="font-weight-bold"
                              htmlFor="title"
                            >
                              Title (optional)
                            </label>
                            <Field
                              name="title"
                              type="text"
                              className={`form-control${errors.title && touched.title ? ' is-invalid' : ''}`}
                            />
                            <ErrorMessage
                              name="title"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </Col>
                      </Row>
                      {
                        canUpdateStatus && (
                          <Row className="w-100">
                            <Col md={12} lg={12}>
                              <div className="form-group">
                                {/* eslint-disable-next-line max-len */}
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="font-weight-bold"
                                  htmlFor="slug"
                                >
                                  Slug
                                </label>
                                <Field
                                  name="slug"
                                  type="text"
                                  className={`form-control${errors.slug && touched.slug ? ' is-invalid' : ''}`}
                                  onChange={(e) => {
                                    const slug = e.target.value
                                      .toLowerCase()
                                      .replace(/[^a-z0-9]+/g, '-');
                                    setFieldValue('slug', slug);
                                  }}
                                />
                                <ErrorMessage
                                  name="slug"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </Col>
                          </Row>
                        )
                      }
                      <Row className="mb-2">
                        <Col>
                          <TinyMceField
                            formikProps={formikProps}
                            fieldName="body"
                            visibleName="Description"
                            onChangeCallback={() => handleChange('body')}
                          />
                        </Col>
                      </Row>
                      {canUpdateStatus && (
                        <Row>
                          <Col>
                            <Select
                              className={`mb-2 form-control${errors.status && touched.status ? ' is-invalid' : ''}`}
                              placeholder="Choose a status..."
                              options={[
                                {
                                  label: 'accepted',
                                  value: 'accepted',
                                },
                                {
                                  label: 'pending',
                                  value: 'pending',
                                },
                                {
                                  label: 'rejected',
                                  value: 'rejected',
                                },
                              ]}
                              isDisabled={!canUpdateStatus}
                              onChange={(e) => {
                                setFieldValue('status', e?.value);
                                setFieldTouched('status');
                              }}
                              value={values.status
                                ? {
                                  label: values.status,
                                  value: values.status,
                                }
                                : {}}
                            />
                            <ErrorMessage
                              name="status"
                              component="div"
                              className="invalid-feedback"
                            />
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col xs={12}>
                          <h2 className="text-blue-500">Puppy Images</h2>
                        </Col>
                        <CloudinaryUploadField
                          cloudinaryWidgetParams={
                            {
                              uploadPreset: CLOUDINARY_UPLOAD_PRESET_TESTIMONIAL,
                            }
                          }
                          shouldUpload={false}
                          shouldAllowImages={true}
                          shouldAllowVideos={false}
                          shouldAllowExternalMedia={false}
                          onMediaChange={(newMedia) => {
                            if (!isEqual(newMedia, values.images)) {
                              setFieldValue('images', newMedia);
                            }
                          }}
                          initialImageMedia={values.images}
                          maxMediaCount={3}
                          updateStart={() => {
                            setCloudinaryIsUpdating(true);
                          }}
                          updateComplete={() => {
                            setCloudinaryIsUpdating(false);
                          }}
                          onSortEnd={() => setFieldTouched('images')}
                        />
                      </Row>
                      <div className="form-group mb-0">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading || !isValid || !dirty}
                        >
                          {
                            loading
                              ? (
                                <>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  <span className="visually-hidden">Loading...</span>
                                </>
                              )
                              : (<>Submit</>)
                          }
                        </button>
                        <RecaptchaDisclaimer />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Form>
        );
      }}
    </Formik>
  );
};

export default TestimonialForm;
